<template>
  <sticky-header-layout>
    <template #header>
      <list-page-header>
        <div slot="right">
          <el-button
            :disabled="isLoading"
            class="cancel-button"
            size="mini"
            type="warning"
            icon="el-icon-close"
            @click="handleCancel"
          >
            {{ $t('button.cancel') }}
          </el-button>
        </div>
      </list-page-header>
    </template>

    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column
        prop="date"
        label="Date"
        width="150"
      />
      <el-table-column
        prop="transactionid"
        label="TransactionID"
        min-width="60"
      />
      <el-table-column
        prop="item_name"
        label="Description"
        min-width="150"
      />
      <el-table-column
        prop="amount"
        label="Amount"
        width="100"
      >
        <template slot-scope="{ row }">
          <span>{{ row.currency }} {{ row.amount }}</span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="Action"
        align="center"
        width="65"
      >
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-download"
            circle
            @click="handleDownload(row)"
          />
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :disabled="isLoading"
        :current-page="listQuery.page"
        :page-sizes="listQuery.sizes"
        :page-size="listQuery.size"
        :total="listQuery.total"
        background
        layout="total, sizes, pager, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </div>
  </sticky-header-layout>
</template>

<script>
import useTablePaging from '../../mixins/useTablePaging'
import { getStoreSubscriptionBilling } from '../../api/stores'

export default {
  name: 'StoreSubscriptionBillingList',
  mixins: [useTablePaging],
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await getStoreSubscriptionBilling({
          page: this.listQuery.page,
          size: this.listQuery.size,
          storeId: this.id,
        })

        const { data, pagination } = response
        // const { billings } = data

        if (Array.isArray(data)) {
          this.list = data
        }
        this.listQuery.total = +pagination.total_items
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    handleCancel() {
      this.$router.push({ path: '/store/list' })
    },
    handleDownload(row) {
      window.open(row.pdf_url, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>

